import React, { useState } from "react";
import styled from "@emotion/styled";
import TtgFeature from "../TtgFeature";

const QueryContainer = styled.div`
  background-color: ${(props) =>
    props.theme.type === "light"
      ? props.theme.gray.gray100
      : props.theme.gray.gray800};
  padding: 8px 12px;
  border-radius: 8px;
  margin: 4px 0;
  font-size: 14px;
  color: ${(props) => props.theme.text.secondary};
  border: none;
  cursor: pointer;

  .query-header {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${(props) => props.theme.success};
    font-size: 14px;
    font-weight: 500;
    margin-bottom: ${(props) => (props.expanded ? "8px" : "0")};
  }

  .query-content {
    max-height: ${(props) => (props.expanded ? "300px" : "0")};
    font-family: monospace;
    white-space: pre-wrap;
    font-size: 12px;
    overflow-y: auto;
    overflow-x: hidden;
    transition: max-height 0.3s ease;
  }
`;

const QueryBlock = ({ content }) => {
  const [expanded, setExpanded] = useState(false);

  if (!content) return null;

  let parsed;
  try {
    parsed = JSON.parse(content);
  } catch (e) {
    return null;
  }

  if (parsed.type !== "sql_query") return null;

  return (
    <TtgFeature>
      {({ treeIcon }) => (
        <QueryContainer
          expanded={expanded}
          onClick={() => setExpanded(!expanded)}
        >
          <div className="query-header">{treeIcon} SQL Query</div>
          <div className="query-content">{parsed.query}</div>
        </QueryContainer>
      )}
    </TtgFeature>
  );
};

export default QueryBlock;
